import React from 'react';
import Lottie from 'lottie-react';

const LottieAnimation = ({ src, style }) => {
  return (
    <Lottie
      autoplay
      loop
      animationData={src}
      style={style || { height: '320px', width: '400px' }}
    />
  );
};

export default LottieAnimation;